import axios from 'axios';
import router from '../router/index.js'

axios.defaults.timeout = 5000;
axios.defaults.baseURL ='';

//http request 拦截器
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    config.data = JSON.stringify(config.data);
    config.headers = {
      'Content-Type':'application/json'
    }
    if(token){
      config.headers.token = token;
    }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);
//http response 拦截器
axios.interceptors.response.use(
  response => {
    const data = response.data;
    if(data.code != 200){
      console.log(data.msg);
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
    .then(response => {
      resolve(response.data.result);
    })
    .catch(err => {
      reject(err)
    })
  })
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
 export function post(url,data = {}){
   return new Promise((resolve,reject) => {
     axios.post(url,data)
          .then(response => {
            resolve(response.data.result);
          },err => {
            reject(err)
          })
   })
 }

 /**
  * 封装get方法，订单侠
  * @param url
  * @param data
  * @returns {Promise}
  */
 export function ddxGet(url,params={}){
   return new Promise((resolve,reject) => {
     axios.get(url,{
       params:params
     })
     .then(response => {
       resolve(response.data.data);
     })
     .catch(err => {
       reject(err)
     })
   })
 }
 /**
  * 封装post方法，订单侠
  * @param url
  * @param data
  * @returns {Promise}
  */
 export function ddxPost(url,data={}){
   return new Promise((resolve,reject) => {
     axios.post(url,data)
          .then(response => {
            resolve(response.data.data);
          },err => {
            reject(err)
          })
   })
 }
